import { createAction, props } from "@ngrx/store";
import { ErrorModel } from "@spartacus/core";
import { CustomProduct } from "../../../product-list-page/models/custom-product.model";

export const fetchProductPriceAction = createAction(
    '[Home Page] Fetch Product Price',
    props<{ productCodes:string[] }>()
);

export const fetchProductPriceActionSuccess = createAction(
    '[Home Page] Fetch Product Price Success',
    props<{ priceItems: CustomProduct[] }>()
);

export const fetchProductPriceActionFail = createAction(
  '[Home Page] Fetch Product Price Fail',
  props<{ error: string; productCodes: string[] }>()
);